"use client"

import { usePathname } from "next/navigation"
import { useEffect, useState } from "react"
import { WhatsAppIcon } from "@/components/whatsapp-icon"
import {
  isCadastroEntrarSupportInlinePath,
  isCadastroSignupShellPath,
} from "@/lib/support/inline-support-paths"
import { waitUntilAfterHero } from "@/lib/ui/wait-until-after-hero"
import {
  buildPublicSupportWhatsAppMessage,
  buildSupportWhatsAppUrl,
} from "@/lib/whatsapp/support-link"
import { cn } from "@/lib/utils"

function isHiddenPath(pathname: string | null): boolean {
  if (!pathname) return false
  if (pathname.startsWith("/admin")) return true
  if (pathname.startsWith("/parceiro")) return true
  if (pathname.startsWith("/render")) return true
  if (pathname.startsWith("/preview")) return true
  if (pathname.startsWith("/painel")) return true
  return false
}

/**
 * Botão flutuante de atendimento via WhatsApp (link externo wa.me).
 * Não depende de cookie consent — não carrega scripts de terceiros nem cookies no site.
 * Some em /painel: a Ajuda já abre o WhatsApp, e o botão cobria o conteúdo.
 * Em /cadastro o atendimento fica no card "Dúvidas?" (mobile e desktop), então o balão não aparece.
 * /cadastro/contato-recebido não é esse shell: no desktop o balão continua.
 * Em /entrar no mobile, o CTA fica inline acima dos pilares.
 */
export function WhatsAppSupportFloatingButton() {
  const pathname = usePathname()
  const [isReady, setIsReady] = useState(false)

  useEffect(() => {
    return waitUntilAfterHero(() => setIsReady(true))
  }, [])

  if (!isReady || isHiddenPath(pathname)) {
    return null
  }

  const href = buildSupportWhatsAppUrl({ text: buildPublicSupportWhatsAppMessage() })
  const onCadastro = isCadastroSignupShellPath(pathname)
  const hideOnMobileInlineFlow = isCadastroEntrarSupportInlinePath(pathname)

  return (
    <a
      data-whatsapp-support-fab
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Falar com a Astra pelo WhatsApp"
      className={cn(
        "fixed z-[85] flex size-14 items-center justify-center rounded-full bg-[#25D366] text-white shadow-lg",
        "transition-transform hover:scale-105 hover:bg-[#20bd5a] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#25D366] focus-visible:ring-offset-2",
        "bottom-6 right-6 max-sm:bottom-20 print:hidden",
        onCadastro && "hidden",
        !onCadastro && hideOnMobileInlineFlow && "max-lg:hidden",
      )}
    >
      <WhatsAppIcon className="size-7" />
    </a>
  )
}
